import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'toggle-switch',
    components: {

    },
})

export default class ToggleSwitch extends Vue {

    // --------------------------------------------------------------------------
    // Properties

    @Prop()
    private selectedConfig: any;

    private isChecked: boolean = false;


    // --------------------------------------------------------------------------
    // Hooks

    private created() {
        const tenantSettings = this.selectedConfig.tenantConfig;
        if (tenantSettings && tenantSettings.value) {
            this.isChecked = tenantSettings.value === 'on' ? true : false;
        }
    }

    // --------------------------------------------------------------------------
    // Actions

    private onChangeConfig() {
        this.$emit('onChangeConfig', (this.isChecked ? 'on' : 'off'));
    }
}
